import * as api from '../api';
import axios from 'axios';
// import router from '../routerManuaConfig'
import Vue from 'vue';
let base = api.BaseApiUrl;

//获取表单配置列表
export const GetTalentTaletnDatilList = params => {
    return axios.get(`${base}/api/TalentDic/GetTalentTaletnDatilList`, { params: params });
};
//删除表单项
export const DeleteTalentDic = data => {
    return axios.delete(`${base}/api/TalentDic/DeleteTalentDic`, { params: data });
};
//新增表单项
export const AddTalentDic = data => {
    return axios.post(`${base}/api/TalentDic/AddTalentDicDetail`, data);
};
//新增表单项
export const UpdateTalentDic = data => {
    return axios.post(`${base}/api/TalentDic/UpdateTalentDicDetail`, data);
};
//获取表单配置详情
export const GetTalentTaletnDatil = params => {
    return axios.get(`${base}/api/TalentDic/GetTalentDetailByDicId`, { params: params });
};
//查询模板信息
export const GetFiletemplate = params => {
    return axios.get(`${base}/api/IntegralTalent/GetFiletemplatedetails`, { params: params });
};
//上传模板信息
export const UploadIntegralFile = data => {
    return axios.post(`${base}/api/IntegralTalent/UpdateIntegralFile`, data);
};
//查询申报人员
export const GetApprovlByPage = data => {
    return axios.post(`${base}/api/Approvl/GetApprovlByPage`, data);
};
//删除申报人员
export const DeleteApprovle = data => {
    return axios.get(`${base}/api/Approvl/DeleteApprovle`, { params: data });
};
//查询申报人员详情
export const GetIntegraltalentDetails = data => {
    // return axios.get(`${base}/api/Approvl/GetIntegraltalentDetails`, { params: data });
    return axios.get(`${base}/api/Approvl/GetApprovleTalentdetails`, { params: data });
};
//审核申报人员
export const PutApprovlState = data => {
    return axios.post(`${base}/api/Approvl/PutApprovlState`, data);
};